/*
|
| Importing Styles
|--------------------------------
*/
import 'swiper/dist/css/swiper.min.css';
import '../sass/app.scss';

/*
|
| Importing Libs & dependencies
|--------------------------------
*/
import jqueryModule from 'jquery';
const $ = window.jQuery || jqueryModule;
window.$ = $;
window.jQuery = $;

import Swiper from 'swiper/dist/js/swiper.min';

/*
|
| Importing Utils
|----------------------------
*/
import './utils/fa';
import Router from './utils/router.js';

/*
|
| Importing App files
|----------------------
*/
import main from './pages/main.js';

/*
|
| Routing
|----------
*/
const routes = new Router([
	{
		'file': main,
		'dependencies': [Swiper]
	}
]);

/*
|
| Run
|------
*/
(($) => { routes.load() })(jQuery);
